/**
 * Plugin Nuxt : configure le @donoor/data-layer pour donoor.org.
 *
 * donoor.org est le SITE PUBLIC : pas d'auth, pas d'orgId stocké
 * globalement. Le getOrganizationId est néanmoins fourni (retourne null)
 * pour permettre à la factory de fonctionner avec `allowedWithoutOrg: true`.
 *
 * Pour les pages de donation où l'org est inférée depuis le QR code / campaign,
 * l'orgId est passé en paramètre direct (pas via ApiContext).
 */
import { setApiContext } from "@donoor/data-layer";

export default defineNuxtPlugin({
  name: "donoor-data-layer",
  enforce: "default",
  setup(nuxtApp) {
    const config = useRuntimeConfig();

    setApiContext({
      apiUrl: config.public.apiUrl as string,
      // Pas d'auth côté site public
      getAuthToken: () => null,
      // Pas d'orgId global côté site public (peut être passé en param par
      // les queries publiques qui en ont besoin).
      getOrganizationId: () => null,
      // Pas de handler 401 (pas de session)
      // Langue de la PAGE (pas celle du navigateur) : l'API la retient à la
      // création d'un paiement pour écrire au payeur dans sa langue
      // (confirmation, reçu, remboursement…). `Accept-Language` est un
      // en-tête « sûr » pour le navigateur (pas de requête CORS préalable) :
      // aucun appel ne peut être bloqué par son ajout.
      getExtraHeaders: () => ({ "Accept-Language": nuxtApp.$i18n.locale.value }),
    });
  },
});
